import React, { Component } from 'react';
import { CookiesProvider } from 'react-cookie';
import axios from 'axios';
import Header from '../../../Components/V2/Header';
import Footer from '../../../Components/V2/Footer';
import Title from '../../../Components/V2/Category/Title';
import Pagination from '../../../Components/V2/Category/Pagination';
import Article from '../../../Components/V2/Category/Article';
import LatestPosts from '../../../Components/V2/Category/LatestPosts';
import SubCategories from '../../../Containers/V2/NewsCategory/SubCategories';
import './style.scss';
export default class NewsCategory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      category: {},
      articles: [],
      highlight: [],
      currentPage: 1,
      totalPage: 0,
    };
  }

  componentDidMount() {
    axios
      .get('/api/v1/articles', {
        params: {
          page: 1,
          limit: 10,
        },
      })
      .then(({ data }) => {
        if (data.success) {
          this.setState({
            highlight: data.payload.articles,
          });
        }
      });
    this.getArticlesCategory(1);
  }

  getArticlesCategory = (page) => {
    const { match } = this.props;
    let uri = '/api/v1/article-page-custom';
    if (match.params.category_slug) {
      uri = `/api/v1/articles/article-category/${match.params.category_slug}`;
    }
    axios
      .get(uri, {
        params: {
          page: page,
          limit: 10,
        },
      })
      .then(({ data }) => {
        if (data.success) {
          let p = {
            currentPage: page,
            totalPage: data.payload.total,
            articles: data.payload.articles,
          };
          if (Object.keys(this.state.category).length === 0) {
            p.category = data.payload.category;
          }
          this.setState(p);
        }
      });
  };

  render() {
    return (
      <CookiesProvider>
        <div className='category-page'>
          <Header />
          {/* <Intro /> */}
          <Title
            title={this.state.category?.category_name}
            color_category={this.state.category?.background_color}
          />
          <main className='main_content sidebar_right pb-50'>
            <div class='container'>
              <div class='row'>
                <div class='col-lg-8 col-md-12 col-sm-12'>
                  <div class='loop-grid row'>
                    {this.state.articles.map((item) => (
                      <Article key={item.id} item={item} />
                    ))}
                  </div>
                  <Pagination
                    currentPage={this.state.currentPage}
                    totalPage={this.state.totalPage}
                    onChange={this.getArticlesCategory}
                  />
                </div>
                <div class='col-lg-4 col-md-12 col-sm-12 primary-sidebar sticky-sidebar'>
                  <div class='widget-area pl-30'>
                    <SubCategories />
                    <LatestPosts
                      posts={this.state.highlight}
                      title='Tiêu điểm'
                    />
                  </div>
                </div>
              </div>
            </div>
          </main>
          <Footer />
        </div>
      </CookiesProvider>
    );
  }
}
